/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_Url_PlaceholderInputs */



/**
* | output |
* | --- |
* | "VDB, VTESDecks, or Amaranth URL" |
*
* @param {Deck_Upload_Url_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_url_placeholder = /** @type {((inputs?: Deck_Upload_Url_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_Url_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL VDB, VTESDecks, ou Amaranth")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL de VDB, VTESDecks o Amaranth")
	if (locale === "pt") return /** @type {LocalizedString} */ ("URL VDB, VTESDecks, ou Amaranth")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL VDB, VTESDecks, o Amaranth")
	return /** @type {LocalizedString} */ ("VDB, VTESDecks, or Amaranth URL")
});